var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "12", height: "20", viewBox: "0 0 12 20" }, props),
    React.createElement("path", { fill: "#606060", fillRule: "evenodd", d: "M2.494 7.686L6 10.753l3.506-3.067c.312-.273.786-.242 1.058.07.273.312.242.786-.07 1.058l-4 3.5c-.283.248-.705.248-.988 0l-4-3.5c-.312-.272-.343-.746-.07-1.058.272-.312.746-.343 1.058-.07z" })
  );
});